<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
          </div>
          <!-- <div class="container"> -->
          <h3 class="text-black mt-5">Essential System Data</h3>
          <div class="row">
            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Internal Departments
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in internalDeptArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editInternalDept(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteInternalDept(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/userDepartment"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewInternalDepartment')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Departments
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in traineeDeptArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editTraineeDept(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteTraineeDept(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/department"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewTraineeDepartment')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Thematic Areas
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in thematicArr"
                      v-bind:key="index"
                    >
                      {{item.name}}
                      <span style="width:60px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editThematic(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteThematic(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/addThematicArea"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewThematicArea')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Funding Agency
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in agencyArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editAgency(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteAgency(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/fundingAgency"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewFundingAgency')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Internal Designations
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in internalDesigArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editInternalDesig(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteInternalDesig(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/designation"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewInternalDesignation')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Designations
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in traineeDesigArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editTraineeDesig(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteTraineeDesig(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/relation-designation"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewTraineeDesignation')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Event Types
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in trainingTypeArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editType(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteType(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/trainingType"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewTrainingType')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Academic Qualification
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in academicArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editAcademic(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteAcademic(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/academicInfo"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewAcademicQualification')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">Country</h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in countryArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editCountry(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteCountry(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/country"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewCountry')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Provinces
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in provinceArr"
                      v-bind:key="index"
                    >
                      {{item.title}} - {{item.country.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editProvince(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteProvince(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/province"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewProvince')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Districts
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in distArr"
                      v-bind:key="index"
                    >
                      {{item.title}}, {{item.province.title}},
                      {{item.province.country.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editDist(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteDist(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/city"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewDistrict')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Relations
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in relationArr"
                      v-bind:key="index"
                    >
                      {{item.title}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editRelation(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteRelation(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/relation-designation"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewRelation')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-5">
            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Professions
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in professionArr"
                      v-bind:key="index"
                    >
                      {{item.name}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editProfession(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteProfession(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <router-link
                      to="/dashboard/Admin/profession"
                      class="add-new bg-clr-orange text-center w-100 view-all"
                    >
                      <h6 style="margin-bottom: 0px !important">View all</h6>
                    </router-link>
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add"
                    >
                      <a @click="$bvModal.show('addNewProfession')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">
                    Nationality
                  </h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in nationalityArr"
                      v-bind:key="index"
                    >
                      {{item.name}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editNationality(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteNationality(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add2"
                    >
                      <a @click="$bvModal.show('addNewNationality')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Sector -->
            <div class="col-md-6 col-lg-3 mt-4">
              <div class="card bordr-rds h-100">
                <div class="card-body bg-light-blue bordr-rds">
                  <h6 class="text-black text-center text-uppercase">Sector</h6>
                  <ul class="list-group mt-2 mb-2 myScroll">
                    <li
                      class="d-flex justify-content-between align-items-center mb-1"
                      v-for="(item,index) in sectorArr"
                      v-bind:key="index"
                    >
                      {{item.name}}
                      <span style="width:50px">
                        <i
                          class="material-icons text-primary f-17"
                          @click="editSector(item.id)"
                          >edit</i
                        >
                        |
                        <i
                          class="material-icons text-danger f-17"
                          @click="deleteSector(item.id)"
                          >delete</i
                        >
                      </span>
                    </li>
                  </ul>
                  <div class="d-flex card-btns">
                    <div
                      class="add-new bg-clr-orange text-center w-100 view-add2"
                    >
                      <a @click="$bvModal.show('addNewSector')">
                        <h6 style="margin-bottom: 0px !important">+ Add New</h6>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- addNewInternalDepartment -->
    <b-modal id="addNewInternalDepartment" hide-footer hide-header>
      <form @submit.prevent="addDepartment">
        <div style="padding: 40px">
          <h5 class="text-center">Add Internal Department</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name</label>
              <input
                type="text"
                v-model="title"
                class="form-control"
                placeholder="Enter name of department"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="code"
                class="form-control"
                placeholder="Enter code of department"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewInternalDepartment')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewInternalDepartment" hide-footer hide-header>
      <form @submit.prevent="updateDepartment" class="bmodal-style">
        <div style="padding: 40px">
          <h5 class="text-center">Update Internal Department</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name</label>
              <input
                type="text"
                v-model="titleEdit"
                class="form-control"
                placeholder="Enter name of department"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="codeEdit"
                class="form-control"
                placeholder="Enter code of department"
              />
            </div>
            <input type="hidden" name="internalDeptId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewInternalDepartment')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <!--addNewTraineeDepartment-->
    <b-modal id="addNewTraineeDepartment" hide-footer hide-header>
      <form @submit.prevent="addTraineeDepartment">
        <div style="padding: 40px">
          <h5 class="text-center">Add Department</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name</label>
              <input
                type="text"
                v-model="titleTrn"
                class="form-control"
                placeholder="Enter name of department"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="codeTrn"
                class="form-control"
                placeholder="Enter code of department"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewTraineeDepartment')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewTraineeDepartment" hide-footer hide-header>
      <form @submit.prevent="updateTraineeDepartment" class="bmodal-style">
        <div style="padding: 40px">
          <h5 class="text-center">Update Department</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name</label>
              <input
                type="text"
                v-model="titleEditTrn"
                class="form-control"
                placeholder="Enter name of trainee's department"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="codeEditTrn"
                class="form-control"
                placeholder="Enter code of trainee's department"
              />
            </div>
            <input type="hidden" name="traineeDeptId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewTraineeDepartment')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewThematicArea-->
    <b-modal id="addNewThematicArea" hide-footer hide-header>
      <form @submit.prevent="addThematic">
        <div style="padding: 40px">
          <h5 class="text-center">Add Thematic Area</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Thematic Area</label>
              <input
                type="text"
                v-model="thematicTitle"
                class="form-control"
                placeholder="Enter name of thematic area"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewThematicArea')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewThematicArea" hide-footer hide-header>
      <form @submit.prevent="updateThematic" class="bmodal-style">
        <div style="padding: 40px">
          <h5 class="text-center">Update Thematic Area</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Thematic Area</label>
              <input
                type="text"
                v-model="thematicTitleEdit"
                class="form-control"
                placeholder="Enter name of thematic area"
              />
            </div>
            <input type="hidden" name="thematicId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewThematicArea')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewFundingAgency-->
    <b-modal id="addNewFundingAgency" hide-footer hide-header>
      <form @submit.prevent="addAgency">
        <div style="padding: 40px">
          <h5 class="text-center">Add Funding Agency</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Organization Name</label>
              <input
                type="text"
                v-model="agnTitle"
                class="form-control"
                placeholder="Enter name of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="agnCode"
                class="form-control"
                placeholder="Enter code of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Person Name</label>
              <input
                type="text"
                v-model="personName"
                class="form-control"
                placeholder="Enter focal person name of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Contact #</label>
              <input
                type="text"
                v-model="contactNo"
                v-mask="'(9999) 9999999'"
                class="form-control"
                placeholder="Enter contact number of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Email</label>
              <input
                type="text"
                v-model="email"
                class="form-control"
                placeholder="Enter valid email address"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Logo</label>
              <div>
                <b-form-file
                  v-model="image"
                  :state="Boolean(image)"
                  placeholder="Choose Logo..."
                  @change="readImage"
                  type="file"
                ></b-form-file>
              </div>
              <b-img
                v-if="url"
                :src="url"
                v-bind="{width: 75, height: 75, class: 'm1'}"
                rounded
              ></b-img>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewFundingAgency')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewFundingAgency" hide-footer hide-header>
      <form @submit.prevent="updateAgency">
        <div style="padding: 40px">
          <h5 class="text-center">Update Funding Agency</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Organization Name</label>
              <input
                type="text"
                v-model="agnTitleEdit"
                class="form-control"
                placeholder="Enter name of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="agnCodeEdit"
                class="form-control"
                placeholder="Enter code of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Person Name</label>
              <input
                type="text"
                v-model="personNameEdit"
                class="form-control"
                placeholder="Enter focal person name of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Contact #</label>
              <input
                type="text"
                v-model="contactNoEdit"
                v-mask="'(9999) 9999999'"
                class="form-control"
                placeholder="Enter contact number of funding agency"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Email</label>
              <input
                type="text"
                v-model="emailEdit"
                class="form-control"
                placeholder="Enter valid email address"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Logo</label>
              <div>
                <b-form-file
                  v-model="imageEdit"
                  :state="Boolean(image)"
                  placeholder="Choose Logo..."
                  @change="readImage"
                  type="file"
                ></b-form-file>
              </div>
              <b-img
                v-if="url"
                :src="url"
                v-bind="{width: 75, height: 75, class: 'm1'}"
                rounded
              ></b-img>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewFundingAgency')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewInternalDesignation-->
    <b-modal id="addNewInternalDesignation" hide-footer hide-header>
      <form @submit.prevent="addInternalDesig">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Internal Designation)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold"
                >Name of Internal Designation</label
              >
              <input
                type="text"
                v-model="internalDesigTitle"
                class="form-control"
                placeholder="Enter name of internal designation"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewInternalDesignation')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewInternalDesignation" hide-footer hide-header>
      <form @submit.prevent="updateInternalDesig">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Internal Designation)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold"
                >Name of Internal Designation</label
              >
              <input
                type="text"
                v-model="internalDesigTitleEdit"
                class="form-control"
                placeholder="Enter name of internal designation"
              />
            </div>
            <input type="hidden" name="internalDesigId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewInternalDesignation')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewTraineeDesignation-->
    <b-modal id="addNewTraineeDesignation" hide-footer hide-header>
      <form @submit.prevent="addTraineeDesig">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Designation)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Designation</label>
              <input
                type="text"
                v-model="traineeDesigTitle"
                class="form-control"
                placeholder="Enter name of trainee designation"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewTraineeDesignation')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewTraineeDesignation" hide-footer hide-header>
      <form @submit.prevent="updateTraineeDesig">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Designation)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Designation</label>
              <input
                type="text"
                v-model="traineeDesigTitleEdit"
                class="form-control"
                placeholder="Enter name of trainee designation"
              />
            </div>
            <input type="hidden" name="traineeDesigId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewTraineeDesignation')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewTrainingType-->
    <b-modal id="addNewTrainingType" hide-footer hide-header>
      <form @submit.prevent="addType">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Event Type)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Event Type</label>
              <input
                type="text"
                v-model="typeTitle"
                class="form-control"
                placeholder="Enter name of event type"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewTrainingType')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewTrainingType" hide-footer hide-header>
      <form @submit.prevent="updateType">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Training Type)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Training Type</label>
              <input
                type="text"
                v-model="typeTitleEdit"
                class="form-control"
                placeholder="Enter name of training type"
              />
            </div>
            <input type="hidden" name="typeId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewTrainingType')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewAcademicQualification-->
    <b-modal id="addNewAcademicQualification" hide-footer hide-header>
      <form @submit.prevent="addAcademic">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Academic Qualification)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold"
                >Name of Degree / Certificate</label
              >
              <input
                type="text"
                v-model="acdTitle"
                class="form-control"
                placeholder="Enter name of degree/certificate, i.e. BS, MS, etc."
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewAcademicQualification')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewAcademicQualification" hide-footer hide-header>
      <form @submit.prevent="updateAcademic">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Academic Qualification)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold"
                >Name of Degree / Certificate</label
              >
              <input
                type="text"
                v-model="acdTitleEdit"
                class="form-control"
                placeholder="Enter name of degree/certificate, i.e. BS, MS, etc."
              />
            </div>
            <input type="hidden" name="acdId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewAcademicQualification')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewCountry-->
    <b-modal id="addNewCountry" hide-footer hide-header>
      <form @submit.prevent="addCountry">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Country)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Country</label>
              <input
                type="text"
                v-model="cTitle"
                class="form-control"
                placeholder="Enter name of the country"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="cCode"
                class="form-control"
                placeholder="Enter code of the country, PK(for Pakistan), etc"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewCountry')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewCountry" hide-footer hide-header>
      <form @submit.prevent="updateCountry">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Country)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Country</label>
              <input
                type="text"
                v-model="cTitleEdit"
                class="form-control"
                placeholder="Enter name of the country"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Code</label>
              <input
                type="text"
                v-model="cCodeEdit"
                class="form-control"
                placeholder="Enter code of the country, PK(for Pakistan), etc"
              />
            </div>
            <input type="hidden" name="cId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewCountry')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!--addNewProvince-->
    <b-modal id="addNewProvince" hide-footer hide-header>
      <form @submit.prevent="addProvince">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Province)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Province</label>
              <input
                type="text"
                v-model="pTitle"
                class="form-control"
                placeholder="Enter name of the province"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Country</label>
              <selectize
                id="select-state"
                class="text-capitalize"
                v-model="pCountryId"
                :settings="countrySetting"
                :searchable="true"
              >
                <option
                  v-for="(item,index) in countryArr"
                  :key="index"
                  :value="item.id"
                  :text="item.title"
                  class="text-capitalize"
                >
                  {{item.title}}
                </option>
              </selectize>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewProvince')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewProvince" hide-footer hide-header>
      <form @submit.prevent="updateProvince">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Province)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Province</label>
              <input
                type="text"
                v-model="pTitleEdit"
                class="form-control"
                placeholder="Enter name of the province"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Country</label>
              <selectize
                id="select-state"
                class="text-capitalize"
                v-model="pCountryIdEdit"
                :settings="countrySetting"
                :searchable="true"
              >
                <option
                  v-for="(item,index) in countryArr"
                  :key="index"
                  :value="item.id"
                  :text="item.title"
                  class="text-capitalize"
                >
                  {{item.title}}
                </option>
              </selectize>
            </div>
            <input type="hidden" name="pId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewProvince')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!-- addNewDistrict -->
    <b-modal id="addNewDistrict" hide-footer hide-header>
      <form @submit.prevent="addDist">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (District/City)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of District/City</label>
              <input
                type="text"
                v-model="distTitle"
                class="form-control"
                placeholder="Enter name of the district/city"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Province & Country</label>
              <selectize
                id="select-state"
                class="text-capitalize"
                v-model="distProvinceId"
                :settings="provinceSetting"
                :searchable="true"
              >
                <option
                  v-for="(item,index) in provinceArr"
                  :key="index"
                  :value="item.id"
                  :text="item.title"
                  class="text-capitalize"
                >
                  {{item.title}} - {{item.country.title}}
                </option>
              </selectize>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewDistrict')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewDistrict" hide-footer hide-header>
      <form @submit.prevent="updateDist">
        <div style="padding: 40px">
          <h5 class="text-center">Update (District/City)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of District/City</label>
              <input
                type="text"
                v-model="distTitleEdit"
                class="form-control"
                placeholder="Enter name of the district/city"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">Province & Country</label>
              <selectize
                id="select-state"
                class="text-capitalize"
                v-model="distProvinceIdEdit"
                :settings="provinceSetting"
                :searchable="true"
              >
                <option
                  v-for="(item,index) in provinceArr"
                  :key="index"
                  :value="item.id"
                  :text="item.title"
                  class="text-capitalize"
                >
                  {{item.title}} - {{item.country.title}}
                </option>
              </selectize>
            </div>
            <input type="hidden" name="distId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewDistrict')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!-- addNewRelation -->
    <b-modal id="addNewRelation" hide-footer hide-header>
      <form @submit.prevent="addRelation">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Relation)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Relation</label>
              <input
                type="text"
                v-model="traineeRelTitle"
                class="form-control"
                placeholder="Enter name of trainee relation"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewRelation')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewRelation" hide-footer hide-header>
      <form @submit.prevent="updateRelation">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Relation)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Relation</label>
              <input
                type="text"
                v-model="traineeRelTitleEdit"
                class="form-control"
                placeholder="Enter name of trainee relation"
              />
            </div>
            <input type="hidden" name="traineeRelId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewRelation')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Add New Profession -->
    <b-modal id="addNewProfession" hide-footer hide-header>
      <form @submit.prevent="addProfession">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Profession)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Profession</label>
              <input
                type="text"
                v-model="traineeProfTitle"
                class="form-control"
                placeholder="Enter name of trainee profession"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewProfession')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewProfession" hide-footer hide-header>
      <form @submit.prevent="updateProfession">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Profession)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name of Profession</label>
              <input
                type="text"
                v-model="traineeProfTitleEdit"
                class="form-control"
                placeholder="Enter name of trainee profession"
              />
            </div>
            <input type="hidden" name="traineeProfId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewProfession')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Add New Nationalit -->
    <b-modal id="addNewNationality" hide-footer hide-header>
      <form @submit.prevent="addNationality">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Nationality)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Nationality</label>
              <input
                type="text"
                v-model="traineeNatTitle"
                class="form-control"
                placeholder="Enter Nationality"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewNationality')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewNationality" hide-footer hide-header>
      <form @submit.prevent="updateNationality">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Nationality)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Nationality</label>
              <input
                type="text"
                v-model="traineeNatTitleEdit"
                class="form-control"
                placeholder="Enter Nationality"
              />
            </div>
            <input type="hidden" name="traineeNatId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewNationality')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>

    <!-- Add New Sector -->
    <b-modal id="addNewSector" hide-footer hide-header>
      <form @submit.prevent="addSector">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Sector)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Sector</label>
              <input
                type="text"
                v-model="sectorTitle"
                class="form-control"
                placeholder="Enter Sector"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Add</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewSector')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal id="editNewSector" hide-footer hide-header>
      <form @submit.prevent="updateSector">
        <div style="padding: 40px">
          <h5 class="text-center">Update (Sector)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Sector</label>
              <input
                type="text"
                v-model="sectorTitleEdit"
                class="form-control"
                placeholder="Enter Sector"
              />
            </div>
            <input type="hidden" name="traineeNatId" />
          </div>
          <div class="d-flex justify-content-center">
            <b-button
              type="submit"
              class="mt-3 mr-1 modal-btn"
              variant="primary"
              >Update</b-button
            >
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('editNewSector')"
              >Cancel</b-button
            >
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import Selectize from "vue2-selectize";


export default {
  data: () => ({
    base_url: process.env.VUE_APP_BASE_PATH,
    countrySetting: {
      maxItems: 1,
      searchField: ["text"],
      placeholder: "Select country here"
    },
    provinceSetting: {
      maxItems: 1,
      searchField: ["text"],
      placeholder: "Select province & country here"
    },
    isActve1: 1,
    isSidebar: false,
    colorx: "warning",
    internalDeptArr: [],
    title: "",
    code: "",
    internalDeptId: "",
    titleEdit: "",
    codeEdit: "",
    // trainee dept
    traineeDeptArr: [],
    titleTrn: "",
    codeTrn: "",
    traineeDeptId: "",
    titleEditTrn: "",
    codeEditTrn: "",
    // thematic area
    thematicArr: [],
    thematicTitle: "",
    thematicTitleEdit: "",
    // funding agency
    agencyArr: [],
    agnTitle: "",
    agnCode: "",
    personName: "",
    contactNo: "",
    email: "",
    image: "",
    url: "",
    agnTitleEdit: "",
    agnCodeEdit: "",
    personNameEdit: "",
    contactNoEdit: "",
    emailEdit: "",
    imageEdit: "",
    // internal designation
    internalDesigArr: [],
    internalDesigTitle: "",
    internalDesigTitleEdit: "",
    internalDesigId: "",

    // Trainee designation
    traineeDesigArr: [],
    traineeDesigTitle: "",
    traineeDesigTitleEdit: "",
    traineeDesigId: "",

    // training types
    trainingTypeArr: [],
    typeTitle: "",
    typeTitleEdit: "",
    typeId: "",

    // country
    countryArr: [],
    cTitle: "",
    cCode: "",
    cTitleEdit: "",
    cCodeEdit: "",
    cId: "",
    // province
    provinceArr: [],
    pTitle: "",
    pCountryId: "",
    pTitleEdit: "",
    pCountryIdEdit: "",
    pId: "",
    // district/city
    distArr: [],
    distTitle: "",
    distTitleEdit: "",
    distProvinceId: "",
    distProvinceIdEdit: "",
    distId: "",

    // trainee relations
    relationArr: [],
    traineeRelTitle: "",
    traineeRelTitleEdit: "",
    traineeRelId: "",

    // Trainee Profession
    professionArr: [],
    traineeProfTitle: "",
    traineeProfTitleEdit: "",
    traineeProfId: "",

     // Trainee Nationality
    nationalityArr: [],
    traineeNatTitle: "",
    traineeNatTitleEdit: "",
    traineeNatId: "",

     // Sector
    sectorArr: [],
    sectorTitle: "",
    sectorTitleEdit: "",
    sectorId: "",
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    Selectize
  },
  created() {},
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.internalDepartment();
    this.traineeDepartment();
    this.allThematic();
    this.allAgency();
    this.allInternalDesig();
    this.allTraineeDesig();
    this.allTrainingType();
    this.allAcadmic();
    this.allCountries();
    this.allProvince();
    this.allDistrict();
    this.allRelation();
    this.allProfession();
    this.allNationality();
    this.allSector();
  },
  methods: {
    // shows internal departments
    internalDepartment: function internalDepartment() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/user/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.internalDeptArr = response.data;
        });
    },
    // add new department
    addDepartment(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.title) {
        this.inValid.push("Department name is required.");
      }
      if (!this.code) {
        this.inValid.push("Code is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/user/department/add", {
            title: this.title,
            code: this.code
          }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }

            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              self.resetForm();
              this.$bvModal.hide("addNewInternalDepartment");
              self.internalDepartment();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    editInternalDept(id){
      this.openLoading();
      this.internalDeptId = "";
      this.titleEdit = "";
      this.codeEdit = "";
        axios.get(
          process.env.VUE_APP_BASE_PATH +
            "/user/departments/" +id+"/edit"
        ).then(response => {
            this.closeLoading();
            if(response){
              this.internalDeptId = response.data.id;
              this.titleEdit = response.data.title;
              this.codeEdit = response.data.code;
              this.$bvModal.show("editNewInternalDepartment");
            }
          })
    },
    updateDepartment(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.titleEdit) {
        this.inValid.push("Department name is required.");
      }
      if (!this.codeEdit) {
        this.inValid.push("Code is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/user/departments/update", {
            title: this.titleEdit,
            code: this.codeEdit,
            id: this.internalDeptId
          }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }

            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              this.$bvModal.hide("editNewInternalDepartment");
              self.internalDepartment();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    deleteInternalDept(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                process.env.VUE_APP_BASE_PATH + "/user/departments/delete",
                {
                  id: id
                }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }

                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.internalDepartment();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },

    // trainees departments
    traineeDepartment: function traineeDepartment() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.traineeDeptArr = response.data;
        });
    },
    addTraineeDepartment(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.titleTrn) {
        this.inValid.push("Department name is required.");
      }
      if (!this.codeTrn) {
        this.inValid.push("Code is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/department/add", {
            title: this.titleTrn,
            code: this.codeTrn
          }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }

            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              self.resetForm();
              this.$bvModal.hide("addNewTraineeDepartment");
              self.traineeDepartment();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    editTraineeDept(id){
      this.openLoading();
      this.traineeDeptId = "";
      this.titleEditTrn = "";
      this.codeEditTrn = "";
        axios.get(process.env.VUE_APP_BASE_PATH + "/departments/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if(response){
              this.traineeDeptId = response.data.id;
              this.titleEditTrn = response.data.title;
              this.codeEditTrn = response.data.code;
              this.$bvModal.show("editNewTraineeDepartment");
            }
          })
    },
    updateTraineeDepartment(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.titleEditTrn) {
        this.inValid.push("Department name is required.");
      }
      if (!this.codeEditTrn) {
        this.inValid.push("Code is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/departments/update", {
            title: this.titleEditTrn,
            code: this.codeEditTrn,
            id: this.traineeDeptId
          }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }

            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              this.$bvModal.hide("editNewTraineeDepartment");
              self.traineeDepartment();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    deleteTraineeDept(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                process.env.VUE_APP_BASE_PATH + "/departments/delete",
                {
                  id: id
                }
              )
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.traineeDepartment();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },


    // thematic areas
    allThematic: function allThematic() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/show/thematicArea/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.thematicArr = response.data;
        });
    },
    addThematic(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.thematicTitle) {
        this.inValid.push("Thematic Area name is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/register/thematicArea", {
            title: this.thematicTitle,
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              self.resetForm();
              this.$bvModal.hide("addNewThematicArea");
              self.allThematic();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    editThematic(id){
      this.openLoading();
      this.thematicId = "";
      this.thematicTitleEdit = "";
        axios.get(process.env.VUE_APP_BASE_PATH + "/thematicArea/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if(response){
              this.thematicId = response.data.id;
              this.thematicTitleEdit = response.data.name;
              this.$bvModal.show("editNewThematicArea");
            }
          })
    },
    updateThematic(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.thematicTitleEdit) {
        this.inValid.push("Thematic Area name is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/thematicArea/update", {
            title: this.thematicTitleEdit,
            id: this.thematicId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              this.$bvModal.hide("editNewThematicArea");
              self.allThematic();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    deleteThematic(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                process.env.VUE_APP_BASE_PATH + "/thematicArea/delete",
                {
                  id: id
                }
              )
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allThematic();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },


    // funding agency
    allAgency: function allAgency() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/funding-agency/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.agencyArr = response.data;
        });
    },
    readImage(input) {
      const file = input.target.files[0];
      if (file.type == "image/jpeg" || file.type == "image/png") {
        this.url = URL.createObjectURL(file);
      } else {
        this.$toasted.global.errorMsg("Please upload Image with jpeg or png format");
        this.url = "";
      }
    },
    addAgency(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.agnTitle) {
        this.inValid.push("Title is required.");
      }
      if (!this.agnCode) {
        this.inValid.push("Code is required.");
      }
      if (!this.personName) {
        this.inValid.push("PersonName is required.");
      }
      if (!this.contactNo) {
        this.inValid.push("Contact number is required.");
      }
      var phone_no1 = this.contactNo;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        let formData = new FormData();
        formData.append("image", this.image);
        formData.append("title", this.agnTitle);
        formData.append("code", this.agnCode);
        formData.append("personName", this.personName);
        formData.append("contactNo", this.contactNo);
        formData.append("email", this.email);
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH + "/funding-agency/add",
            formData
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              self.resetForm();
              this.$bvModal.hide("addNewFundingAgency");
              self.allAgency();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    editAgency(id) {
      this.openLoading();
      this.imageEdit = "";
      this.agnTitleEdit = "";
      this.agnCodeEdit = "";
      this.personNameEdit = "";
      this.contactNoEdit = "";
      this.emailEdit = "";
      this.agencyId = "";
      this.url = "";
      axios
        .get(
          process.env.VUE_APP_BASE_PATH + "/funding-agency/" + id + "/edit"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.url = this.base_url+'/'+response.data.image;
            this.imageEdit = response.data.image;
            this.agnTitleEdit = response.data.title;
            this.agnCodeEdit = response.data.code;
            this.personNameEdit = response.data.personName;
            this.contactNoEdit = response.data.contactNo;
            this.emailEdit = response.data.email;
            this.agencyId = id;
            this.$bvModal.show("editNewFundingAgency");
          }
        });
    },
    updateAgency(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.agnTitleEdit) {
        this.inValid.push("Name is required.");
      }
      if (!this.agnCodeEdit) {
        this.inValid.push("Department is required.");
      }
      if (!this.personNameEdit) {
        this.inValid.push("Designation is required.");
      }
      if (!this.contactNoEdit) {
        this.inValid.push("Contact number is required.");
      }
      if (!this.emailEdit) {
        this.inValid.push("An Email address is required.");
      }
      var phone_no1 = this.contactNoEdit;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;

        let formData = new FormData();

        formData.append("image", this.imageEdit);
        formData.append("title", this.agnTitleEdit);
        formData.append("code", this.agnCodeEdit);
        formData.append("personName", this.personNameEdit);
        formData.append("contactNo", this.contactNoEdit);
        formData.append("email", this.emailEdit);
        formData.append("id", this.agencyId);

        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH + "/funding-agency/update",
            formData
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              this.$bvModal.hide("editNewFundingAgency");
              self.allAgency();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    deleteAgency(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(
                process.env.VUE_APP_BASE_PATH + "/funding-agency/delete",
                {
                  id: id
                }
              )
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allAgency();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },

    // internal designation
    allInternalDesig: function allInternalDesig() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/designations/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.internalDesigArr = response.data;
        });
    },
    editInternalDesig(id) {
      this.openLoading();
      this.internalDesigTitleEdit = "",
      this.internalDesigId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/designation/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.internalDesigTitleEdit = response.data.title;
            this.internalDesigId = response.data.id;
            this.$bvModal.show("editNewInternalDesignation");
          }
        });
    },
    deleteInternalDesig(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/designation/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allInternalDesig();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addInternalDesig(e) {
      let self = this;
      e.preventDefault();
      if (this.internalDesigTitle == "") {
        self.toastError("Internal designation title is required.");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:

        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/designation/add", {
            title: this.internalDesigTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allInternalDesig();
              this.$bvModal.hide("addNewInternalDesignation");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateInternalDesig(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.internalDesigTitleEdit) {
        this.inValid.push("Internal designation title is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/designation/update", {
            title: this.internalDesigTitleEdit,
            id: this.internalDesigId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allInternalDesig();
              this.$bvModal.hide("editNewInternalDesignation");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // trainee designation
    allTraineeDesig: function allTraineeDesig() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.traineeDesigArr = response.data;
        });
    },
    editTraineeDesig(id) {
      this.openLoading();
      this.traineeDesigTitleEdit = "",
      this.traineeDesigId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/traineedesignation/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.traineeDesigTitleEdit = response.data.title;
            this.traineeDesigId = response.data.id;
            this.$bvModal.show("editNewTraineeDesignation");
          }
        });
    },
    deleteTraineeDesig(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/traineedesignation/single/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allTraineeDesig();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addTraineeDesig(e) {
      let self = this;
      e.preventDefault();
      if (this.traineeDesigTitle == "") {
        self.toastError("Designation title is required.");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:

        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/trainee-designation/add", {
            title: this.traineeDesigTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allTraineeDesig();
              this.$bvModal.hide("addNewTraineeDesignation");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateTraineeDesig(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.traineeDesigTitleEdit) {
        this.inValid.push("Designation title is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/traineedesignation/single/update", {
            title: this.traineeDesigTitleEdit,
            id: this.traineeDesigId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
               self.resetForm();
              self.allTraineeDesig();
              this.$bvModal.hide("editNewTraineeDesignation");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // training type
    allTrainingType: function allTrainingType() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/show/trainigtype/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainingTypeArr = response.data;
        });
    },
    editType(id) {
      this.typeTitleEdit = "";
      this.typeId = "";
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH + "/trainingtype/" + id + "/edit"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.typeTitleEdit = response.data.title;
            this.typeId = response.data.id;
            this.$bvModal.show("editNewTrainingType");
          }
        });
    },
    deleteType(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/trainigtype/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allTrainingType();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addType(e) {
      e.preventDefault();

      this.inValid = [];
      let self = this;
      if (!this.typeTitle) {
        this.inValid.push("Please enter training type");
      }
      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/register/trainingtype", {
            trainigType: this.typeTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allTrainingType();
              this.$bvModal.hide("addNewTrainingType");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateType(e) {
      e.preventDefault();
      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      let self = this;
      this.inValid = [];
      if (!this.typeTitleEdit) {
        this.inValid.push("Please enter training type");
      }
      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/trainingtype/update", {
            title: this.typeTitleEdit,
            id: this.typeId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.resetForm();
              self.toastSuccess("Record has been updated successfully!");
              self.allTrainingType();
              this.$bvModal.hide("editNewTrainingType");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            this.$toasted.global.errorMsg(error);
          });
      }
    },

    // academic information add
    allAcadmic: function allAcadmic() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.academicArr = response.data;
        });
    },
    editAcademic(id) {
      this.openLoading();
      this.acdTitleEdit = "";
      this.acdId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/degreenames/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.acdTitleEdit = response.data.title;
            this.acdId = response.data.id;
            this.$bvModal.show("editNewAcademicQualification");
          }
        });
    },
    deleteAcademic(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/degreenames/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allAcadmic();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addAcademic(e) {
      let self = this;
      e.preventDefault();
      if (this.acdTitle == "") {
        this.$toasted.global.errorMsg('Degree name is required.');
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/degreenames/add", {
            title: this.acdTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.resetForm();
              self.toastSuccess("Record has been saved successfully!");
              self.allAcadmic();
              this.$bvModal.hide("addNewAcademicQualification");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateAcademic(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.acdTitleEdit) {
        this.inValid.push("Title is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/degreenames/update", {
            title: this.acdTitleEdit,
            id: this.acdId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.allAcadmic();
              this.$bvModal.hide("editNewAcademicQualification");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // country
    allCountries: function allCountries() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/countries/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.countryArr = response.data;
        });
    },
    editCountry(id) {
      this.cTitleEdit = "";
      this.cCodeEdit = "";
      this.cId = "";
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/country/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.cTitleEdit = response.data.title;
            this.cCodeEdit = response.data.code;
            this.cId = response.data.id;
            this.$bvModal.show("editNewCountry");
          }
        });
    },
    deleteCountry(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/country/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allCountries();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addCountry(e) {
      e.preventDefault();
      this.inValid = [];

      if (!this.cTitle) {
        this.inValid.push("Title is required.");
      }
      if (!this.cCode) {
        this.inValid.push("Code is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/country/add", {
            title: this.cTitle,
            code: this.cCode
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been Added successfully!");
              self.resetForm();
              self.allCountries();
              this.$bvModal.hide("addNewCountry");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateCountry(e) {
      e.preventDefault();
      if (this.cTitleEdit == "" && this.cCodeEdit == "") {
        this.error = "All fields are required. Fill out all fields, please!";
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/country/update", {
            title: this.cTitleEdit,
            code: this.cCodeEdit,
            id: this.cId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allCountries();
              self.$bvModal.hide("editNewCountry");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // provinces
    allProvince: function allProvince() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.provinceArr = response.data;
        });
    },
    editProvince(id) {
      this.pTitleEdit = "";
      this.pCountryIdEdit = "";
      this.pId = "";
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/provinces/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.pTitleEdit = response.data.title;
            this.pCountryIdEdit = response.data.country_id;
            this.pId = response.data.id;
            this.$bvModal.show("editNewProvince");
          }
        });
    },
    deleteProvince(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/provinces/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allProvince();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addProvince(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.pTitle) {
        this.inValid.push(" Province name is required.");
      }
      if (!this.pCountryId) {
        this.inValid.push("Country is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/province/add", {
            title: this.pTitle,
            country_id: this.pCountryId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              this.allProvince();
              this.$bvModal.hide("addNewProvince");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateProvince(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.pTitleEdit) {
        this.inValid.push("Province is required.");
      }
      if (!this.pCountryIdEdit) {
        this.inValid.push("Country is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/province/update", {
            title: this.pTitleEdit,
            country_id: this.pCountryIdEdit,
            id: this.pId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.resetForm();
              self.toastSuccess("Record has been updated successfully!");
              this.$bvModal.hide("editNewProvince");
              self.allProvince();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // districts
    allDistrict: function allDistrict() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.distArr = response.data;
        });
    },
    editDist(id) {
      this.distTitleEdit = "";
      this.distProvinceIdEdit = "";
      this.distId = "";
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/district/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.distTitleEdit = response.data.title;
            this.distProvinceIdEdit = response.data.province_id;
            this.distId = response.data.id;
            this.$bvModal.show("editNewDistrict");
          }
        });
    },
    deleteDist(id) {
      let self = this;
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/district/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allDistrict();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                self.toastError(error);
              });
          }
        });
    },
    addDist(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.distTitle) {
        this.inValid.push("District/City name is required.");
      }
      if (!this.distProvinceId) {
        this.inValid.push("Select Province & Country is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/district/add", {
            title: this.distTitle,
            province_id: this.distProvinceId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              this.$bvModal.hide("addNewDistrict");
              this.allDistrict();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateDist(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.distTitleEdit) {
        this.inValid.push("District/City name is required.");
      }
      if (!this.distProvinceIdEdit) {
        this.inValid.push("Select Province & Country is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/district/update", {
            title: this.distTitleEdit,
            province_id: this.distProvinceIdEdit,
            id: this.distId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              this.$bvModal.hide("editNewDistrict");
              self.resetForm();
              self.allDistrict();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // trainee relations
    allRelation: function allRelation() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/relation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.relationArr = response.data;
        });
    },
    editRelation(id) {
      this.openLoading();
      this.traineeRelTitleEdit = "",
      this.traineeRelId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/relation/" + id + "/edit"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.traineeRelTitleEdit = response.data.title;
            this.traineeRelId = response.data.id;
            this.$bvModal.show("editNewRelation");
          }
        });
    },
    deleteRelation(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/relation/single/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allRelation();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addRelation(e) {
      let self = this;
      e.preventDefault();
      if (this.traineeRelTitle == "") {
        self.toastError("Relation title is required.");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:

        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/relation/add", {
            title: this.traineeRelTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allRelation();
              this.$bvModal.hide("addNewRelation");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateRelation(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.traineeRelTitleEdit) {
        this.inValid.push("Relation title is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/relation/single/update", {
            title: this.traineeRelTitleEdit,
            id: this.traineeRelId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
               self.resetForm();
              self.allRelation();
              this.$bvModal.hide("editNewRelation");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

    // Trainee Profession
     allProfession: function allProfession() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/professions/get"
        )
        .then(response => {

          this.closeLoading();
          this.professionArr = response.data;
        });
    },
    editProfession(id) {
      this.openLoading();
      this.traineeProfTitleEdit = "",
      this.traineeProfId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/professions/get/"+ id,
        )
        .then(response => {

          this.closeLoading();
          if (response) {
            this.traineeProfTitleEdit = response.data.name;
            this.traineeProfId = response.data.id;
            this.$bvModal.show("editNewProfession");
          }
        });
    },
    deleteProfession(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/professions/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allProfession();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addProfession(e) {
      let self = this;
      e.preventDefault();
      if (this.traineeProfTitle == "") {
        self.toastError("Profession is required.");
      } else {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:

        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/professions/add", {
            name: this.traineeProfTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allProfession();
              this.$bvModal.hide("addNewProfession");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateProfession(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.traineeProfTitleEdit) {
        this.inValid.push("Profession title is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/professions/update", {
            name: this.traineeProfTitleEdit,
            id: this.traineeProfId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
               self.resetForm();
              self.allProfession();
              this.$bvModal.hide("editNewProfession");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

      // Trainee Nationality
     allNationality: function allNationality() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/nationalities/get"
        )
        .then(response => {

          this.closeLoading();
          this.nationalityArr = response.data;
        });
    },
    editNationality(id) {
      this.openLoading();
      this.traineeNatTitleEdit = "",
      this.traineeNatId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/nationalities/get/"+ id,
        )
        .then(response => {

          this.closeLoading();
          if (response) {
            this.traineeNatTitleEdit = response.data.name;
            this.traineeNatId = response.data.id;
            this.$bvModal.show("editNewNationality");
          }
        });
    },
    deleteNationality(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/nationalities/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allNationality();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addNationality(e) {
      let self = this;
      e.preventDefault();
      if (this.traineeNatTitle == "") {
        self.toastError("Nationality is required.");
      } else {

        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/nationalities/add", {
            name: this.traineeNatTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allNationality();
              this.$bvModal.hide("addNewNationality");
            } else if (response.data.error) {
              throw response.data.error.errors[0].message;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateNationality(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.traineeNatTitleEdit) {
        this.inValid.push("Nationality is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/nationalities/update", {
            name: this.traineeNatTitleEdit,
            id: this.traineeNatId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
               self.resetForm();
              self.allNationality();
              this.$bvModal.hide("editNewNationality");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },

      //  Sector
     allSector: function allSector() {
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/sectors/get"
        )
        .then(response => {

          this.closeLoading();
          this.sectorArr = response.data;
        });
    },
    editSector(id) {
      this.openLoading();
      this.sectorTitleEdit = "",
      this.sectorId = "";
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/sectors/get/"+ id,
        )
        .then(response => {

          this.closeLoading();
          if (response) {
            this.sectorTitleEdit = response.data.name;
            this.sectorId = response.data.id;
            this.$bvModal.show("editNewSector");
          }
        });
    },
    deleteSector(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/sectors/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.resetForm();
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allSector();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    addSector(e) {
      let self = this;
      e.preventDefault();
      if (this.sectorTitle == "") {
        self.toastError("Sector is required.");
      } else {

        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/sectors/add", {
            name: this.sectorTitle
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allSector();
              this.$bvModal.hide("addNewSector");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    updateSector(e) {
      e.preventDefault();
      this.inValid = [];
      let self = this;
      if (!this.sectorTitleEdit) {
        this.inValid.push("Sector is required.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/sectors/update", {
            name: this.sectorTitleEdit,
            id: this.sectorId
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
               self.resetForm();
              self.allSector();
              this.$bvModal.hide("editNewSector");
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },


    // Reset form elements
    resetForm() {
      this.title = "";
      this.code = "";
      this.titleTrn = "";
      this.codeTrn = "";
      this.thematicTitle = "";
      this.agnTitle = "";
      this.agnCode = "";
      this.personName = "";
      this.contactNo = "";
      this.email = "";
      this.image = "";
      this.imageEdit = "";
      this.url = "";
      this.internalDesigTitle = "";
      this.internalDesigTitleEdit = "";
      this.traineeDesigTitle = "";
      this.traineeDesigTitleEdit = "";
      this.traineeRelTitle = "";
      this.traineeRelTitleEdit = "";
      this.typeTitle = "";
      this.typeTitleEdit = "";
      this.cTitle = "";
      this.cCode = "";
      this.cTitleEdit = "";
      this.cCodeEdit = "";
      this.pTitle = "";
      this.pTitleEdit = "";
      this.pCountryId = "";
      this.pCountryIdEdit = "";
      this.distTitle = "";
      this.distTitleEdit = "";
      this.distProvinceId = "";
      this.distProvinceIdEdit = "";
      this.traineeProfTitle= "";
      this.traineeProfTitleEdit= "";
      this.traineeNatTitle= "";
      this.traineeNatTitleEdit= "";
      this.sectorTitle= "";
      this.sectorTitleEdit= "";

    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 3000,
        variant: "danger",
        solid: true
      });
    }
  }
};
</script>

<style scoped>
.myScroll {
  min-height: 150px;
  max-height: 150px;
  overflow-y: auto;
  margin-bottom: 40px !important;
}
h6,
i {
  cursor: pointer;
}
.card-body {
  padding: 10px !important;
}
.bg-light-blue {
  background-color: #eff4ff !important;
}
.bordr-rds {
  border-radius: 15px !important;
}
.f-17 {
  font-size: 17px !important;
}
.addnew {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  font-weight: 600;
}

.btn-smbt {
  background-color: #007bff !important;
  border: 1px solid #007bff;
  color: #fff !important;
  font-size: 14px;
  padding: 3px 35px !important;
  margin-right: 5px;
}

.btn-smbt:active,
.btn-smbt:hover,
.btn-smbt:focus,
.btn-smbt:visited {
  background-color: #007bff !important;
  border: 1px solid #007bff;
  color: #fff !important;
  font-size: 14px;
  padding: 3px 35px !important;
}

.btn-cncl {
  background-color: #fff !important;
  border: 1px solid #007bff;
  color: #007bff !important;
  font-size: 14px;
  padding: 3px 35px !important;
}
.btn-cncl:active,
.btn-cncl:visited,
.btn-cncl:hover,
.btn-cncl:focus {
  background-color: #fff !important;
  border: 1px solid #007bff;
  color: #007bff !important;
  font-size: 14px;
  padding: 3px 35px !important;
}
.modal-btn {
  padding: 0px 50px;
  height: 30px;
  border-radius: 10px;
}
.card-btns {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.view-all {
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 0px 0px 0px 12px;
}
.view-add {
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 0px 0px 12px 0px;
}
.view-add2 {
  border: 1px solid #e8e8e8;
  padding: 10px;
  border-radius: 0px 0px 12px 12px;
}
</style>
<style>
.modal-dialog {
  background: transparent !important;
}
.modal-dialog input {
  border-radius: 5px !important;
  height: 32px !important;
}
#addNewInternalDepartment___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewInternalDepartment___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* editNewTraineeDepartment */
#addNewTraineeDepartment___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewTraineeDepartment___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewThematicArea */
#addNewThematicArea___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewThematicArea___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewFundingAgency */
#addNewFundingAgency___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewFundingAgency___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewInternalDesignation */
#addNewInternalDesignation___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewInternalDesignation___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewTraineeDesignation */
#addNewTraineeDesignation___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewTraineeDesignation___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewTrainingType */
#addNewTrainingType___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewTrainingType___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewAcademicQualification */
#addNewAcademicQualification___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewAcademicQualification___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewRelation */
#addNewRelation___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewRelation___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewCountry */
#addNewCountry___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewCountry___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewProvince */
#addNewProvince___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewProvince___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
/* addNewDistrict */
#addNewDistrict___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
#editNewDistrict___BV_modal_content_ {
  border-radius: 12px !important;
  background: #f1f1f1 !important;
  border: 1px solid !important;
}
</style>
